import ConfirmDialog from '@/commons/confirm-dialog/ConfirmDialog';
import { Iconic } from '@/commons/iconic';
import { ActionsProps } from '@/components/Table/types/actions';
import { PATH_DASHBOARD } from '@/routes/paths';
import { MenuItem } from '@mui/material';
import { disableOrderById, reOpenOrder, rePrinterFactureService } from '@/services';
import { DialogChangePayMethod } from '@/components/pop-modal/dialog-change-pay-method';
import { useNavigate } from 'react-router-dom';
import { useRole } from '@/hooks/useRole';
import { Roles, translates } from '@/utils';
import DialogMenu from '@/commons/dialog-menu';
import { DialogChangeTips } from '@/components/pop-modal/dialog-change-tips';
import { DialogUnifyAccounts } from '@/components/pop-modal/dialog-unify-accounts';
import { DialogMoveProducts } from '@/components/pop-modal/dialog-move-products';
import { Button } from '@PorkyCol/button';
import { useCompanyCategory } from '@/hooks/useCompanyCategory';
import { OrderStatus } from '../page/cookingPanel';
import { useFetch } from '../hooks/useFetch';

export const ListActionsOrders = ({
  value,
  openConfirm,
  setOpenConfirm,
  setOpenPopover,
  data,
  isActual,
}: ActionsProps) => {
  const navigate_orders: any = {
    view: PATH_DASHBOARD.orders.view,
    edit: PATH_DASHBOARD.orders.edit,
    openOrders: PATH_DASHBOARD.orders.open_orders
  };
  const navigate = useNavigate();
  const { isFoodCompany } = useCompanyCategory();
  const { authorized } = useRole([Roles.ADMIN]);
  const { authorized: authorizedWithAtm } = useRole([Roles.ADMIN, Roles.ATM]);

  const handleDisableOrderById = async (id: string) => {
    try {
      await disableOrderById(id);
    } catch (error) {
      console.log('🚀 ~ file: index.tsx:42 ~ handleDisableOrderById ~ error:', error);
    }
  };

  const { fetchId: fetchRePrinterFacture } = useFetch({ fetchFunction: rePrinterFactureService });
  const handleRePrinterFacture = async () => {
    try {
      fetchRePrinterFacture(value);
    } catch (error) {
      console.log('🚀 ~ file: index.tsx:51 ~ handleRePrinterFacture ~ error:', error);
    }
  };

  const { fetchId: fetchReOpen } = useFetch({ fetchFunction: reOpenOrder });
  const handleReOpen = async () => {
    try {
      await fetchReOpen(value);

      handleClosePopover();
      navigate(PATH_DASHBOARD.orders.open_orders);

    } catch (error) {
      console.log('🚀 ~ file: index.tsx:63 ~ handleReOpen ~ error:', error);
      handleClosePopover();
    }
  };

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleEdit = () => {
    navigate(navigate_orders.edit(value));
  };

  const onDeleteRow = async () => {
    await handleDisableOrderById(value);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  return (
    <>
      {authorizedWithAtm && (
        <MenuItem onClick={handleEdit}>
          <Iconic icon="eva:edit-fill" />
          {translates.edit}
        </MenuItem>
      )}
      {isActual &&
        authorizedWithAtm &&
        data.status === OrderStatus.Closed && [
          <MenuItem onClick={() => handleRePrinterFacture()}>
            <Iconic icon="fluent:receipt-money-24-regular" />
            {translates.printInvoice}
          </MenuItem>,
          isFoodCompany && (
            <DialogMenu
              disabled
              icon="game-icons:receive-money"
              text={`${translates.change} ${translates.tip}`}
              title={translates.changeTipValuesEntered}
              component={(props: any) => <DialogChangeTips value={value} {...props} />}
            />
          ),
          <DialogMenu
            icon="tabler:zoom-money"
            text={translates.paymentMethod}
            title={translates.changeEnteredPaymentValues}
            component={(props: any) => <DialogChangePayMethod value={value} {...props} />}
          />,

          authorized && (
            <MenuItem onClick={() => handleReOpen()}>
              <Iconic icon="tabler:ticket" />
              {translates.reOpenOrder}
            </MenuItem>
          ),
        ]}
      {authorizedWithAtm && data.status !== OrderStatus.Closed && (
        <>
          <DialogMenu
            icon="codicon:combine"
            text="Unificar cuentas"
            title="Unificar cuentas"
            component={(props: any) => <DialogUnifyAccounts value={value} {...props} />}
          />
          <DialogMenu
            icon="material-symbols:production-quantity-limits"
            text="Mover producto"
            title="Mover producto"
            component={(props: any) => <DialogMoveProducts value={data} {...props} />}
          />
          <MenuItem
            onClick={() => {
              handleOpenConfirm();
            }}
            sx={{ color: 'error.main' }}
          >
            <Iconic icon="eva:trash-2-outline" />
            {translates.delete}
          </MenuItem>
        </>
      )}

      <ConfirmDialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        title={translates.delete}
        content={translates.messageDelete}
        action={
          <Button
            variant="solid"
            color="danger"
            onClick={() => {
              onDeleteRow();
              handleClosePopover();
            }}
          >
            {translates.delete}
          </Button>
        }
      />
    </>
  );
};
